// extracted by css-extract-rspack-plugin
export default {"pointer":"rNm3G","seo":"h0vwJ","white-60":"pUcp7","white60":"pUcp7","white-80":"b29xU","white80":"b29xU","seo_expanded":"WVINf","seoExpanded":"WVINf"};